module.exports = __webpack_public_path__ + "static/media/inner.3e6f7f16.jpg";